import { render } from "./HappyBirthday.vue?vue&type=template&id=76e3ea36&scoped=true"
import script from "./HappyBirthday.vue?vue&type=script&lang=js"
export * from "./HappyBirthday.vue?vue&type=script&lang=js"

import "./HappyBirthday.vue?vue&type=style&index=0&id=76e3ea36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e3ea36"]])

export default __exports__